import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { FormField } from '~/eds/src/components/FormField/FormField';
import { useToast } from '~/eds/src/components/hooks/useToast';
import { Modal } from '~/eds/src/components/Modal/Modal';
import { TextInput } from '~/eds/src/components/TextInput/TextInput';
import { api } from '~/redux/api/createApi';

import { ExtendedPartyModalProps } from '../types';

export const UpdatePartyModal = ({
  onHide,
  party,
  clientId,
}: ExtendedPartyModalProps) => {
  const { toast } = useToast();
  const intl = useIntl();
  const [partyName, setPartyName] = useState<string>(party.name);
  const [editParty, { isLoading }] = api.endpoints.updateParty.useMutation();

  const children = (
    <FormField
      label={intl.formatMessage({
        id: 'UpdatePartyModal.partyNameLabel',
        defaultMessage: 'Party Name',
        description: 'Label for party name input field',
      })}
      input={TextInput}
      name="Edit Party Name"
      value={partyName}
      onChange={(updatedPartyName) => setPartyName(updatedPartyName as string)}
    />
  );

  return (
    <Modal
      children={children}
      enableHideOnPrimaryAction={true}
      isVisible={true}
      primaryAction={{
        isLoading,
        text: intl.formatMessage({
          id: 'UpdatePartyModal.saveButton',
          defaultMessage: 'Save',
          description: 'Save button text',
        }),
        disabled: !partyName,
        onClick: () => {
          const updatedParty = { ...party, name: partyName };
          editParty({
            isInternal: party.isInternal,
            oldName: party.name,
            party: updatedParty,
            clientId,
          })
            .unwrap()
            .then(() => {
              toast({
                message: intl.formatMessage(
                  {
                    id: 'UpdatePartyModal.successMessage',
                    defaultMessage:
                      'Party "{oldName}" has been renamed to "{newName}".',
                    description:
                      'Success message when party is renamed. Example: oldName = "ABC Corp", newName = "ABC Corporation"',
                  },
                  {
                    oldName: party.name,
                    newName: updatedParty.name,
                  },
                ),
                status: 'success',
              });
            })
            .catch((error) => {
              toast({
                message: `${error.response.data.detail}`,
                status: 'danger',
              });
            });
          onHide();
        },
        variant: 'primary',
      }}
      onHide={onHide}
      title={intl.formatMessage({
        id: 'UpdatePartyModal.modalTitle',
        defaultMessage: 'Edit Party',
        description: 'Modal title for editing party',
      })}
    />
  );
};
